import { render, staticRenderFns } from "./ProductTabsOne.vue?vue&type=template&id=af5efafe&"
import script from "./ProductTabsOne.vue?vue&type=script&lang=js&"
export * from "./ProductTabsOne.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabsOne.vue?vue&type=style&index=0&id=af5efafe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports